<!-- <div class="nb-theme-default"> -->
<!-- <nb-card>
    <nb-card-body> -->
        <nb-select
         [placeholder]="placeholder" 
         [multiple]="multiple" 
         [status]="status"
         [shape]="shape"
         fullWidth
         [size]="size"
         [hero]="hero"
         [filled]="filled"
         [(selected)]="selected"
         (selectedChange)="sendValue($event)">
            <nb-option disabled value="null">{{menutitle}}</nb-option>
            <nb-option *ngFor="let option of options" [value]="option.value">{{ option.label }}</nb-option>
        </nb-select>
    <!-- </nb-card-body>
</nb-card> -->
<!-- </div> -->